import { useEffect } from 'react';
import { createFileRoute } from '@tanstack/react-router';

import { Loading } from '@crossnokaye/ux-common';

function TokenCallback() {
  useEffect(() => {
    // Get URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');
    const error = urlParams.get('error');
    const errorDescription = urlParams.get('error_description');

    // Post message back to opener window
    if (window.opener && !window.opener.closed) {
      window.opener.postMessage(
        {
          type: 'auth-callback',
          code,
          state,
          error,
          error_description: errorDescription,
        },
        window.location.origin
      );
    }
  }, []);

  return (
    <div className={'flex items-center justify-center min-h-screen'}>
      <div className={'text-center'}>
        <Loading size={'lg'} />
        <p className={'mt-4 text-sm text-muted-foreground'}>{'Processing authentication...'}</p>
      </div>
    </div>
  );
}

export const Route = createFileRoute('/token/callback' as any)({
  component: TokenCallback,
});
